import { BaseModel, ModelInstance, ToFrontHook, ToBackHook, DateField } from './util';
import { TournamentTeamUser } from './tournament-team-user';
import { Team } from './team';
import { TeamUser } from './team-user';
import { User } from './user';
import { TournamentTeam } from './tournament-team';
import { BaseStatistic, WinLoseType } from './base-statistic';
import { LeaguePlayer } from './league-player';

@ModelInstance({
  mappingFields: {
    league_player: 'leaguePlayer',
    tournament_team_user: 'tournamentTeamUser',
    team: 'team',
    team_user: 'teamUser',
    user: 'user',
    tournament_team: 'tournamentTeam',
    month: 'month',
    win_lose: 'winLose',
    games_count: 'gamesCount',
    won_games_count: 'wonGamesCount',
    lose_games_count: 'loseGamesCount',
    team_score_sum: 'teamScoreSum',
    team_missed_sum: 'teamMissedSum',
    tournament_points: 'tournamentPoints',
    points: 'points',
    pp_shots: 'ppShots',
    pp_shot_misses: 'ppShotMisses',
    pp_shots_on_goal: 'ppShotsOnGoal',
    pp_shots_blocked: 'ppShotsBlocked',
    ev_shots: 'evShots',
    ev_shot_misses: 'evShotMisses',
    ev_shots_on_goal: 'evShotsOnGoal',
    ev_shots_blocked: 'evShotsBlocked',
    sh_shots: 'shShots',
    sh_shot_misses: 'shShotMisses',
    sh_shots_on_goal: 'shShotsOnGoal',
    sh_shots_blocked: 'shShotsBlocked',
    pp_goals_percent: 'ppGoalsPercent',
    pp_goals: 'ppGoals',
    ev_goals_percent: 'evGoalsPercent',
    ev_goals: 'evGoals',
    sh_goals_percent: 'shGoalsPercent',
    goals: 'goals',
    total_goals: 'totalGoals',
    sh_goals: 'shGoals',
    shot_misses: 'shotMisses',
    shots_on_goal: 'shotsOnGoal',
    shots_blocked: 'shotsBlocked',
    shots: 'shots',
    total_shots: 'totalShots',
    goals_percent: 'goalsPercent',
    total_goals_percent: 'totalGoalsPercent',
    pp_assists: 'ppAssists',
    ev_assists: 'evAssists',
    sh_assists: 'shAssists',
    shootout_attempts: 'shootoutAttempts',
    shootout_goals: 'shootoutGoals',
    after_game_shootout_attempts: 'afterGameShootoutAttempts',
    after_game_shootout_goals: 'afterGameShootoutGoals',
    block_shots: 'blockShots',
    face_off_losses: 'faceOffLosses',
    face_off_wins: 'faceOffWins',
    face_offs: 'faceOffs',
    face_off_percent: 'faceOffPercent',
    pp_saves: 'ppSaves',
    sh_saves: 'shSaves',
    ev_saves: 'evSaves',
    saves: 'saves',
    total_saves: 'totalSaves',
    shootout_saves: 'shootoutSaves',
    shots_against: 'shotsAgainst',
    shootout_shots_against: 'shootoutShotsAgainst',
    total_shots_against: 'totalShotsAgainst',
    saves_percent: 'savesPercent',
    shootout_saves_percent: 'shootoutSavesPercent',
    total_saves_percent: 'totalSavesPercent',
    pp_goals_against: 'ppGoalsAgainst',
    sh_goals_against: 'shGoalsAgainst',
    ev_goals_against: 'evGoalsAgainst',
    goals_against: 'goalsAgainst',
    shootout_goals_against: 'shootoutGoalsAgainst',
    total_goals_against: 'totalGoalsAgainst',
    safety_rate: 'safetyRate',
    penalty_minutes: 'penaltyMinutes',
    game_time: 'gameTime',
    plus_minus: 'plusMinus',
    steals: 'steals',
    pp_steals: 'ppSteals',
    ev_steals: 'evSteals',
    sh_steals: 'shSteals',
    losses: 'losses',
    pp_losses: 'ppLosses',
    ev_losses: 'evLosses',
    sh_losses: 'shLosses',
    sharp_passes: 'sharpPasses',
    pp_sharp_passes: 'ppSharpPasses',
    ev_sharp_passes: 'evSharpPasses',
    sh_sharp_passes: 'shSharpPasses',
    drawn_fouls: 'drawnFouls',
    efficiency: 'efficiency',
    newbie: 'newbie',
    rank: 'rank',
    shutout: 'shutout',
    shutout_percent: 'shutoutPercent',
    mvp_count: 'mvpCount',
    games_qualified_for_playoff: 'gamesQualifiedForPlayoff'
  },
  relation: {
    leaguePlayer: LeaguePlayer,
    tournamentTeamUser: TournamentTeamUser,
    team: Team,
    teamUser: TeamUser,
    user: User,
    tournamentTeam: TournamentTeam,
    month: DateField
  }
})
export class HockeyStatistic extends BaseModel implements BaseStatistic {
  leaguePlayer: LeaguePlayer;
  tournamentTeamUser: TournamentTeamUser;
  team: Team;
  teamUser: TeamUser;
  user: User;
  tournamentTeam: TournamentTeam;
  month: Date;
  winLose: WinLoseType;
  gamesCount: number;
  wonGamesCount: number;
  loseGamesCount: number;
  teamScoreSum: number;
  teamMissedSum: number;
  tournamentPoints: number;
  points: number;
  ppShots: number;
  ppShotMisses: number;
  ppShotsOnGoal: number;
  ppShotsBlocked: number;
  evShots: number;
  evShotMisses: number;
  evShotsOnGoal: number;
  evShotsBlocked: number;
  shShots: number;
  shShotMisses: number;
  shShotsOnGoal: number;
  shShotsBlocked: number;
  ppGoalsPercent: number;
  ppGoals: number;
  evGoalsPercent: number;
  evGoals: number;
  shGoalsPercent: number;
  shGoals: number;
  goals: number;
  totalGoals: number;
  totalGoalsPercent;
  shotMisses: number;
  shotsOnGoal: number;
  shotsBlocked: number;
  shots: number;
  totalShots: number;
  goalsPercent: number;
  ppAssists: number;
  evAssists: number;
  shAssists: number;
  shootoutAttempts: number;
  shootoutGoals: number;
  afterGameShootoutAttempts: number;
  afterGameShootoutGoals: number;
  blockShots: number;
  faceOffLosses: number;
  faceOffWins: number;
  faceOffs: number;
  faceOffPercent: number;
  savesPercent: number;
  shootoutSavesPercent: number;
  totalSavesPercent: number;
  ppSaves: number;
  evSaves: number;
  shSaves: number;
  saves: number;
  shootoutSaves: number;
  totalSaves: number;
  shotsAgainst: number;
  shootoutShotsAgainst: number;
  totalShotsAgainst: number;
  ppGoalsAgainst: number;
  shGoalsAgainst: number;
  evGoalsAgainst: number;
  goalsAgainst: number;
  shootoutGoalsAgainst: number;
  totalGoalsAgainst: number;
  safetyRate: number;
  penaltyMinutes: number;
  gameTime: number;
  plusMinus: number;
  steals: number;
  ppSteals: number;
  evSteals: number;
  shSteals: number;
  losses: number;
  ppLosses: number;
  evLosses: number;
  shLosses: number;
  sharpPasses: number;
  ppSharpPasses: number;
  evSharpPasses: number;
  shSharpPasses: number;
  drawnFouls: number;
  efficiency: number;
  newbie: boolean;
  rank: number;
  shutout: number;
  shutoutPercent: number;
  mvpCount: number;
  gamesQualifiedForPlayoff: number;

  get assists(): number {
    return Math.floor(10 * ((this.ppAssists || 0) + (this.shAssists || 0) + (this.evAssists || 0))) / 10;
  }

  get goalpass(): number {
    return Math.floor(10 * ((this.totalGoals || 0) + (this.assists || 0))) / 10;
  }

  get userMinutes(): string {
    if (!this.gameTime) {
      return '00:00';
    }
    const minutes = Math.floor(this.gameTime / 60);
    const seconds = Math.floor(this.gameTime - minutes * 60);
    return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
  }

  get gamesWonPercent(): number {
    if (!this.gamesCount) {
      return 0;
    }
    return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
  }

  get tournamentTeamPoints(): number {
    return this.tournamentTeam && this.tournamentTeam.points;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
